import React, { useState } from "react"
import * as sessions from "sessions"
import * as api from "brandguard/api"
import * as bglayouts from "brandguard/components/layouts"
import { CancellablePromise } from "real-cancellable-promise"
import * as httpx from "httpx"

export interface Correction {
	id: string
	status: string
	corrected_event_id?: string
	error_message?: string
}

export interface CorrectionAPI {
	create(eventId: string, ...options: httpx.option[]): CancellablePromise<Correction>
	find(correctionId: string, ...options: httpx.option[]): CancellablePromise<Correction>
	list(eventId: string, ...options: httpx.option[]): CancellablePromise<Correction[]>
}

interface item {
	event?: { id?: string; observation?: number }
}

interface props {
	items: item[]
	corrections: CorrectionAPI
	progressLabel: string
	onCorrectionComplete?: () => void
}

function correctable(item: item): boolean {
	if (item.event?.id === undefined) return false
	const o = item.event.observation
	return (
		o === api.Prediction.REJECTED ||
		o === api.Prediction.INREVIEW ||
		o === api.Prediction.REJECTED_BY_REVIEW ||
		o === api.Prediction.APPROVED_WITH_EDITS
	)
}

export default function GenerateCorrection(props: props): JSX.Element {
	const { items, corrections, progressLabel, onCorrectionComplete } = props
	const bearertoken = sessions.useToken()

	const [creating, setCreating] = useState(false)

	const eligible = items.filter(correctable)

	const handleCreate = (): void => {
		if (eligible.length === 0 || creating) return
		setCreating(true)
		Promise.allSettled(eligible.map((i) => corrections.create(i.event!.id!, bearertoken)))
			.then((results) => {
				results
					.filter((r): r is PromiseRejectedResult => r.status === "rejected")
					.forEach((r) => console.error("bgcorrections: create failed", r.reason))
				if (results.some((r) => r.status === "fulfilled")) onCorrectionComplete?.()
			})
			.finally(() => setCreating(false))
	}

	return (
		<bglayouts.CorrectionToolbarButton onClick={handleCreate} disabled={creating || eligible.length === 0}>
			{creating ? progressLabel + " correction in progress..." : "Generate Correction"}
		</bglayouts.CorrectionToolbarButton>
	)
}
